import type {
  ComponentPageData,
  InlineVideoUnitData,
  NormalizedContentUnit,
} from '@/features/content/useComponent';

export interface PdfVideoLink {
  id: string;
  title: string;
  url: string;
}

export function getYouTubeWatchUrl(videoIdOrUrl: string) {
  const trimmed = videoIdOrUrl.trim();

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return `https://www.youtube.com/watch?v=${encodeURIComponent(trimmed)}`;
}

function isInlineVideoUnit(unit: NormalizedContentUnit): unit is InlineVideoUnitData {
  return unit.kind === 'inlineVideo';
}

function collectInlineVideoLinks(component: ComponentPageData) {
  const links: PdfVideoLink[] = [];

  for (const section of component.sections) {
    for (const unit of section.units) {
      if (!isInlineVideoUnit(unit)) {
        continue;
      }

      links.push({
        id: unit.videoId,
        title: unit.title || unit.summaryLabel || 'Video',
        url: getYouTubeWatchUrl(unit.videoId),
      });
    }
  }

  return links;
}

export function collectPdfVideoLinks(component: ComponentPageData): PdfVideoLink[] {
  const linksById = new Map<string, PdfVideoLink>();

  component.videoIds.forEach((videoId, index) => {
    linksById.set(videoId, {
      id: videoId,
      title: `Video ${index + 1}`,
      url: getYouTubeWatchUrl(videoId),
    });
  });

  for (const link of collectInlineVideoLinks(component)) {
    linksById.set(link.id, link);
  }

  return Array.from(linksById.values());
}
